export default "__VITE_ASSET__jAUkTghs__"